import Main from '@/views/administracion/configuracion/catalogos/Main.vue';
import Default from '@/views/administracion/configuracion/catalogos/Default.vue';
import Entidades from './entidades';
import Municipios from './municipios';
import Contratistas from './contratistas';
import Deducciones from './deducciones';
import Funcionarios from './funcionarios';
import Usuarios from './usuarios';
import FuentesFinancieras from './fuentesfinancieras';
import ProgramasInversion from './programasinversion';
import TiposObra from './tiposobra';
import SubTiposObra from './subtiposobra';
import Etiquetas from './etiquetas';
import ContratosEstatus from './contratosestatus';
import Expedientes from './expedientes';
import TiposDocumentos from './tiposdocumentos';
import Clientes from './clientes';
import Insumos from './insumos';

const auth = ['Catálogos:ver'];
const scopes = ['Catálogos:crear', 'Catálogos:editar', 'Catálogos:eliminar'];

const catalogos = [
  {
    path: 'catalogos',
    meta: {
      title: '',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'catalogos',
        path: '/',
        meta: {
          title: 'Catálogos',
          auth,
          scopes,
        },
        component: Default,
        children: [
          ...Entidades,
          ...Municipios,
          ...Contratistas,
          ...Deducciones,
          ...Funcionarios,
          ...Usuarios,
          ...FuentesFinancieras,
          ...ProgramasInversion,
          ...TiposObra,
          ...SubTiposObra,
          ...Etiquetas,
          ...ContratosEstatus,
          ...Expedientes,
          ...TiposDocumentos,
          ...Clientes,
          ...Insumos,
        ],
      },
    ],
  },
];

export default catalogos;
